import { render, staticRenderFns } from "./Travel.vue?vue&type=template&id=f1cc6fb4&scoped=true&"
import script from "./Travel.vue?vue&type=script&lang=js&"
export * from "./Travel.vue?vue&type=script&lang=js&"
import style0 from "./Travel.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Travel.vue?vue&type=style&index=1&lang=less&"
import style2 from "./Travel.vue?vue&type=style&index=2&id=f1cc6fb4&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1cc6fb4",
  null
  
)

export default component.exports